<template>
  <div class="content media-page">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header data-background-color="blue">
            <div class="header-flex">
              <div class="header-text">
                <h4 class="title">Resumen</h4>
                <p class="category">
                  Vista rápida de tus documentos disponibles. {{ mediaDocs.length }}
                </p>
              </div>
              <md-button class="md-primary" @click="openModal">
                <md-icon>cloud_upload</md-icon>
                Subir documento
              </md-button>
            </div>
          </md-card-header>

          <md-card-content>


            <p v-if="loading">Cargando documentos...</p>
            <p v-else-if="error" class="text-danger">{{ error }}</p>
            <p v-else-if="!mediaDocs.length">
              Todavía no has subido documentos.
            </p>

            <div v-else class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
  <article
    v-for="docItem in mediaDocs"
    :key="docItem.id"
    class="group relative flex flex-col bg-white border border-slate-200 rounded-xl overflow-hidden cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg hover:border-slate-300"
    @click="viewFile(docItem)"
  >
    <!-- Franja superior -->
    <div class="h-1 w-full" :class="documentTone(docItem.type)"></div>

    <div class="flex items-start gap-4 p-5">
      <!-- Icono -->
      <div
        class="flex items-center justify-center w-11 h-11 rounded-xl flex-shrink-0"
        :class="documentTone(docItem.type)"
      >
        <md-icon style="font-size: 20px; color: white;">
          {{ documentIcon(docItem.type) }}
        </md-icon>
      </div>

      <!-- Contenido -->
      <div class="flex-1 min-w-0">
        <!-- Título + badge -->
        <div class="flex items-start justify-between gap-2 mb-3">
          <h4 class="text-sm font-semibold text-slate-800 truncate leading-snug">
            {{ docItem.name || "Sin nombre" }}
          </h4>
          <span
            class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold text-white flex-shrink-0"
            :class="documentTone(docItem.type)"
          >
            {{ friendlyType(docItem.type) }}
          </span>
        </div>

        <!-- Meta -->
        <div class="flex items-center gap-3 pt-3 border-t border-slate-100">
          <div class="flex flex-col gap-0.5">
            <span class="text-[10px] font-semibold text-slate-400">Subido</span>
            <span class="text-xs font-medium text-slate-600">{{ formatValue(docItem.createdAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </article>
</div>
          </md-card-content>

          <md-card-actions>
            <md-button class="md-raised md-primary" @click="loadMediaDocs">
              Recargar
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
    </div>

    <!-- Modal de Carga de Documentos -->
    <md-dialog :md-active.sync="modalOpen" class="upload-dialog" :md-fullscreen="false">
      <md-dialog-title>Cargar nuevo documento</md-dialog-title>

      <md-dialog-content class="upload-dialog-content">
        <div class="iframe-modal-container">
          <iframe src="https://gate.jgmun.com/modal/upload" frameborder="0" class="upload-iframe"></iframe>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="closeModal">Finalizar</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- Visor de Archivos Reutilizable -->
    <FileViewer
      :file-id="selectedFileId"
      :visible="isViewerOpen"
      :hide-projection="true"
      @close="isViewerOpen = false"
      @delete="deleteFile"
    />
  </div>
</template>

<script>
import { collection, getDocs, query, where, doc, deleteDoc } from "firebase/firestore";
import { db } from "@/fb";
import axios from "axios";
import FileViewer from "@/components/FileViewer.vue";

const DEFAULT_COHORT = "cohort2026";
const DEFAULT_COMMISSION_ID = "NQfEjEI8jOHM26Aj9HvQ";

export default {
  name: "MyFilesPage",
  components: { FileViewer },
  data() {
    return {
      loading: false,
      error: "",
      mediaDocs: [],
      modalOpen: false,
      selectedFileId: null,
      isViewerOpen: false,
    };
  },
  computed: {
    currentUserId() {
      return (
        this.$delegateStore.state.delegateData &&
        this.$delegateStore.state.delegateData.delegation &&
        this.$delegateStore.state.delegateData.delegation.id
      );
    },
  },
  created() {
    this.loadMediaDocs();
  },
  methods: {
    documentIcon(type) {
      const normalizedType = String(type || "").toLowerCase();

      if (normalizedType.includes("image")) {
        return "image";
      }

      if (normalizedType.includes("pdf")) {
        return "picture_as_pdf";
      }

      if (normalizedType.includes("video")) {
        return "movie";
      }

      if (normalizedType.includes("audio")) {
        return "music_note";
      }

      return "description";
    },
    openModal() {
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
      this.loadMediaDocs();
    },
    viewFile(item) {
      this.selectedFileId = item.id;
      this.isViewerOpen = true;
    },
    documentTone(type) {
  const t = String(type || "").toLowerCase();
  if (t.includes("image")) return "bg-gradient-to-br from-blue-500 to-indigo-500";
  if (t.includes("pdf"))   return "bg-red-600";
  if (t.includes("video")) return "bg-violet-700";
  if (t.includes("audio")) return "bg-teal-600";
  return "bg-slate-800";
},
    friendlyType(type) {
      if (!type) {
        return "Archivo";
      }

      const normalizedType = String(type).toLowerCase();
      if (normalizedType.includes("image")) {
        return "Imagen";
      }

      if (normalizedType.includes("pdf")) {
        return "PDF";
      }

      if (normalizedType.includes("video")) {
        return "Video";
      }

      if (normalizedType.includes("audio")) {
        return "Audio";
      }

      return "Archivo";
    },
    formatValue(value) {
      if (!value) {
        return "-";
      }

      if (value.seconds !== undefined && value.nanoseconds !== undefined) {
        return new Date(value.seconds * 1000).toLocaleString();
      }

      if (typeof value === "string") {
        return value;
      }

      if (value.toDate && typeof value.toDate === "function") {
        return value.toDate().toLocaleString();
      }

      return JSON.stringify(value);
    },
    async deleteFile(file) {
      if (!file) return;
      if (!confirm('¿Estás seguro de eliminar este archivo permanentemente?')) return;

      try {
        if (file.fileKey) {
          await axios.delete(`https://api.jgmun.com/api/docs/${encodeURIComponent(file.fileKey)}`);
        }

        const authContext = this.$delegateStore.state.authContext || {};
        await deleteDoc(doc(db, `commissions/${authContext.cohort}/commissions/${authContext.commissionId}/media`, file.id));
        
        this.isViewerOpen = false;
        this.loadMediaDocs();
      } catch (err) {
        this.error = "No se pudo eliminar el archivo.";
      }
    },
    async loadMediaDocs() {
      this.loading = true;
      this.error = "";
      this.mediaDocs = [];

      try {
        if (!this.currentUserId) {
          await this.$loadDelegateProfile();
        }

        const authContext = this.$delegateStore.state.authContext || {};
        const delegateData = this.$delegateStore.state.delegateData || {};
        const cohort = authContext.cohort || DEFAULT_COHORT;
        const commissionId = authContext.commissionId || DEFAULT_COMMISSION_ID;
        const delegationId =
          delegateData.delegation && delegateData.delegation.id
            ? delegateData.delegation.id
            : "";

        if (!delegationId) {
          this.error = "No hay usuario autenticado disponible para filtrar los documentos.";
          return;
        }

        const mediaRef = collection(
          db,
          "commissions",
          cohort,
          "commissions",
          commissionId,
          "media"
        );

        const mediaQuery = query(mediaRef, where("uploader.id", "==", delegationId));
        const snapshot = await getDocs(mediaQuery);

        this.mediaDocs = snapshot.docs
          .map((mediaDoc) => ({ id: mediaDoc.id, ...mediaDoc.data() }))
          .sort((left, right) => {
            const leftDate = left.updatedAt?.seconds || left.createdAt?.seconds || 0;
            const rightDate = right.updatedAt?.seconds || right.createdAt?.seconds || 0;
            return rightDate - leftDate;
          });
      } catch (error) {
        this.error =
          "No se pudieron cargar los documentos de media. Verifica la ruta de Firestore y las reglas.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.media-page {
  padding-bottom: 24px;
}

.page-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  padding: 8px 4px 0;
}

.eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #5f6b7a;
}

.page-title {
  margin: 0;
  font-size: 28px;
  line-height: 1.1;
  color: #1f2937;
}

.page-description {
  margin: 8px 0 0;
  max-width: 720px;
  color: #64748b;
}

.media-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.summary-label {
  display: block;
  font-size: 12px;
  text-transform: uppercase;
  opacity: 0.7;
  margin-bottom: 4px;
}

.media-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 18px;
}

.document-card {
  display: flex;
  gap: 16px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 0;
  background: #ffffff;
}

.document-icon {
  width: 52px;
  height: 52px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 52px;
  color: #ffffff;
}

.tone-default {
  background: #23233a;
}

.tone-image {
  background: linear-gradient(135deg, #23233a, #33334d);
}

.tone-pdf {
  background: #b91c1c;
}

.tone-video {
  background: #4c1d95;
}

.tone-audio {
  background: #0f766e;
}

.document-body {
  min-width: 0;
  flex: 1;
}

.document-topline {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.document-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

.document-kind {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 0;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  color: #475569;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  text-transform: uppercase;
}

.document-summary {
  margin: 0 0 14px;
  color: #64748b;
}

.document-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: -1px;
  margin-top: 12px;
}

/* Estilos del Header Flex y el Botón de Carga */
.header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.upload-header-btn {
  background-color: #ffffff !important;
  color: #23233a !important;
  margin: 0 !important;
  font-weight: 600 !important;
}

.upload-dialog {
  max-width: 1200px !important;
  width: 95vw !important;
  border-radius: 0 !important;
  margin: 0;
}

.upload-dialog-content {
  padding: 0 !important; /* Eliminar padding interno del md-dialog-content para que el iframe ocupe todo el espacio */
  overflow: hidden !important;
  border-radius: 0 !important;
}

.iframe-modal-container {
  width: 100%;
  height: 560px;
  padding: 10px;
  overflow: hidden;
  display: flex;
}

.upload-iframe {
  width: 100%;
  height: 100%;
  border: none;
  flex: 1;
}

.upload-dialog {
  border-radius: 0 !important;
}

.meta-cell {
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.meta-label {
  display: block;
  margin-bottom: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #94a3b8;
}

.meta-value {
  display: block;
  color: #1e293b;
  font-size: 12px;
}

.media-meta p {
  margin-bottom: 8px;
  word-break: break-word;
}

.md-card-actions {
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .page-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .document-card {
    flex-direction: column;
  }

  .document-meta {
    grid-template-columns: 1fr;
  }
}
</style>
<style>
.upload-dialog .md-dialog-container {
  width: 680px !important;
  max-width: 95vw !important;
  border-radius: 0 !important;
  max-height: 90vh !important;
  display: flex !important;
  flex-direction: column !important;
}

.upload-dialog .md-dialog-content {
  padding: 0 !important;
  overflow: hidden !important;
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
}
</style>